const state = {
    hasValidEmail: true
};

const getters = {
    hasValidEmail: state => state.hasValidEmail
};

const mutations = {
    setHasValidEmail(state, hasValidEmail) {
        state.hasValidEmail = hasValidEmail;
    }
};

const actions = {
    /**
     *
     * @param {Object} param
     * @param {Object} payload
     */
    isValidEmail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    "/api/v2/_modules/applicants",
                    { email: payload.email },
                    {
                        headers: { Authorization: "Bearer " + payload.token }
                    }
                )
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
